import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DescribedField from '../DescribedField';

const emptyItem = () => ({
  id: crypto.randomUUID(),
  name: '',
  url: '',
});

/**
 * GenericLinksBlockEditor — Editor do bloco Links Gerais
 * TODO 4.15
 *
 * Props:
 *   - value: { items: [{ id, name, url }] }
 *   - onChange: (patch) => void
 *   - context: object
 */
const GenericLinksBlockEditor = ({ value = {}, onChange }) => {
  const { items = [] } = value;

  const patchItems = (newItems) => onChange({ ...value, items: newItems });

  const addItem = () => patchItems([...items, emptyItem()]);

  const removeItem = (index) => patchItems(items.filter((_, i) => i !== index));

  const updateItem = (index, field, val) => {
    const updated = items.map((item, i) =>
      i === index ? { ...item, [field]: val } : item
    );
    patchItems(updated);
  };

  return (
    <DescribedField
      label="Links extras"
      description="Lista de links com rótulo personalizado. Útil para blog, portfólio externo, WhatsApp, cardápio online ou qualquer destino relevante. Cada link aparece como um botão ou item na página. Use a URL completa, incluindo 'https://'."
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {items.map((item, index) => (
          <Paper key={item.id ?? index} variant="outlined" sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="subtitle2">Link {index + 1}</Typography>
              <IconButton
                size="small"
                onClick={() => removeItem(index)}
                aria-label="Remover link"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
            <TextField
              fullWidth
              label="Rótulo"
              value={item.name}
              onChange={(e) => updateItem(index, 'name', e.target.value)}
              size="small"
              sx={{ mb: 1.5 }}
              helperText="Texto do botão (ex.: 'Meu Blog', 'Fale no WhatsApp')."
            />
            <TextField
              fullWidth
              label="URL"
              value={item.url}
              onChange={(e) => updateItem(index, 'url', e.target.value)}
              size="small"
              type="url"
              helperText="Endereço completo, incluindo 'https://'."
            />
          </Paper>
        ))}

        <Button
          startIcon={<AddIcon />}
          onClick={addItem}
          variant="outlined"
          size="small"
          sx={{ alignSelf: 'flex-start' }}
        >
          Adicionar link
        </Button>
      </Box>
    </DescribedField>
  );
};

GenericLinksBlockEditor.propTypes = {
  value: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.object,
};

export default GenericLinksBlockEditor;
